import { DefaultSettings, DeliveryOptionsEnum } from '@as-react/common-types';
import { capitalizeOnly } from '@as-react/common-utils';
import { getHouseNumberNLPattern } from '../components/form/address-fields/addressFields.utils';
export const generateFieldName = (name, prefix) => prefix ? `${prefix}${prefix.endsWith('.') ? name : capitalizeOnly(name)}` : name;
export const isDaysOption = (deliveryOption) => !!deliveryOption &&
    [DeliveryOptionsEnum.NAMED_DAY, DeliveryOptionsEnum.NEXT_DAY, DeliveryOptionsEnum.HOME_DELIVERY].includes(deliveryOption);
export const isUkCountry = (country) => ['GB', 'GG', 'JE'].includes(country);
export const isNextOrNamedDayOptions = (deliveryOptions) => {
    let countOptions = 0;
    deliveryOptions.forEach(opt => {
        if (opt.name === DeliveryOptionsEnum.NAMED_DAY || opt.name === DeliveryOptionsEnum.NEXT_DAY) {
            countOptions++;
        }
    });
    return countOptions === 2;
};
export const isNamedDayOrHomeDeliveryOptions = (deliveryOptions) => {
    let countOptions = 0;
    deliveryOptions.forEach(opt => {
        if (opt.name === DeliveryOptionsEnum.NAMED_DAY || opt.name === DeliveryOptionsEnum.HOME_DELIVERY) {
            countOptions++;
        }
    });
    return countOptions === 2;
};
export const isAllDaysOptions = (deliveryOptions) => {
    let countOptions = 0;
    deliveryOptions.forEach(opt => {
        if (opt.name === DeliveryOptionsEnum.NAMED_DAY ||
            opt.name === DeliveryOptionsEnum.NEXT_DAY ||
            opt.name === DeliveryOptionsEnum.HOME_DELIVERY) {
            countOptions++;
        }
    });
    return countOptions === 3;
};
export const chooseDeliveryOption = (deliveryOptions, deliveryOption) => isDaysOption(deliveryOption) &&
    (isNextOrNamedDayOptions(deliveryOptions) ||
        isNamedDayOrHomeDeliveryOptions(deliveryOptions) ||
        isAllDaysOptions(deliveryOptions))
    ? DeliveryOptionsEnum.NAMED_DAY
    : deliveryOption;
export const filterDeliveryOptions = (deliveryOptions) => {
    if (isNextOrNamedDayOptions(deliveryOptions) ||
        isNamedDayOrHomeDeliveryOptions(deliveryOptions) ||
        isAllDaysOptions(deliveryOptions)) {
        return deliveryOptions.filter(opt => opt.name !== DeliveryOptionsEnum.NEXT_DAY && opt.name !== DeliveryOptionsEnum.HOME_DELIVERY);
    }
    return deliveryOptions;
};
export const showNamedDays = (option) => option.name === DeliveryOptionsEnum.NAMED_DAY ||
    (option.name === DeliveryOptionsEnum.NEXT_DAY && option.namedDayEnabled);
export const getDefaultCountry = (fictiveWebShop) => {
    switch (fictiveWebShop) {
        case '139':
            return 'IE';
        case '142':
            return 'US';
        case '145':
            return 'AU';
        default:
            return 'GB';
    }
};
export const isValidAddress = (postCode, houseNumber, country) => {
    switch (country) {
        case 'NL':
            return (!!postCode &&
                !!houseNumber &&
                new RegExp(DefaultSettings.POSTAL_CODE_NL, 'i').test(postCode) &&
                new RegExp(getHouseNumberNLPattern(houseNumber), 'i').test(houseNumber));
        case 'BE':
            return !!postCode && new RegExp(DefaultSettings.POSTAL_CODE_BE, 'i').test(postCode);
        case 'GB':
        case 'GG':
        case 'JE':
            return !!postCode && new RegExp(DefaultSettings.POSTAL_CODE_UK).test(postCode);
        default:
            return true;
    }
};
export const isValidPostCode = (postCode, country) => {
    switch (country) {
        case 'BE':
            return !!postCode && new RegExp(DefaultSettings.POSTAL_CODE_BE, 'i').test(postCode);
        case 'DE':
        case 'FR':
            return !!postCode && postCode.length === 5;
        default:
            return true;
    }
};
